import React, { useState } from "react";
import berryTalkIcon from "../../assets/images/foriload-logo.png";
import { View } from "@carbon/icons-react";
import { useForm } from "react-hook-form";
import userImg from "../../assets/images/logincar.jpg";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import Constants from "../../utils/Constants";
import { useNavigate } from "react-router-dom";
// import { encrypt, key } from "../../utils/Cipher";
import swal from "sweetalert";
import CryptoJS from "crypto-js";
import { DecryptData, EncryptData } from "../../utils/Cipher";
import { usePermissions } from "../../context/PermissionsContext";

const Login = () => {
  const [viewPassword, setViewPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const { setPermissions } = usePermissions();


  const navigate = useNavigate();

  const handleViewPassword = () => {
    setViewPassword(!viewPassword);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleLogin = (data) => {
    toast("Validating");
    setLoader(true);
    axios({
      method: "post",
      data: data,
      url: Constants.url + "users/login",
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.data.user.role === "customer") {
            toast.error("Invalid Credentials", { position: "top-right" });
            setLoader(false);
            return;
          }

          toast.success("Success", { position: "top-right" });


          setPermissions(res.data.data.permissions);

          localStorage.setItem("token", res.data.token);
          EncryptData(res.data.data.user, res.data.token);

          navigate("/dashboard");
        } else {
          setLoader(false);
        }
      })
      .catch((err) => {
        swal({
          icon : 'error',
          text : err.response.data.message
        })
        setLoader(false);
      });

    // setTimeout(() => {

    // }, 500);
    // setTimeout(() => {
    //   window.location.href = "/dashboard"
    // }, 2000);
  };

  return (
    <>
      <ToastContainer newestOnTop={true} limit={1} />
      <div className="loginWrp">
        <div uk-grid="" className="uk-grid">
          <div className="uk-width-1-2">
            <div className="imgwrp">
              <img src={userImg} alt="" />
            </div>
          </div>
          <div className="uk-width-expand">
            <div className="formwrp">
              <form onSubmit={handleSubmit(handleLogin)}>
                <div className="loginHeading">
                  <h2>Login</h2>
                </div>
                <div uk-gird="">
                  <div className="uk-width-1-1">
                    <div className="inputField">
                      {/* //email validation is in hook-form Validate callback function */}
                      <input
                        {...register("email", {
                          required: "Email is required",
                          validate: (value) => {
                            if (!value.includes("@")) {
                              return "email must include @";
                            }
                          },
                        })}
                        type="text"
                        placeholder="Email or mobile number"
                      />

                      <p className="errorMsg">{errors.email?.message}</p>

                      {/* {errors.email ? (
                        <div className="uk-alert-danger">
                          {" "}
                          Invalid email{" "}
                        </div>
                      ) : (
                        ""
                      )} */}
                    </div>
                  </div>
                  <div className="uk-width-1-1">
                    <div className="inputField">
                      <input
                        {...register("password", {
                          required: "Password is required",
                          validate: (val) => {
                            if (val.length < 8) {
                              return "Password must be greater than 8";
                            }
                          },
                        })}
                        type={viewPassword ? "text" : "password"}
                        placeholder="Password"
                      />

                      <button
                        className="viewIcon"
                        type="button"
                        onClick={handleViewPassword}
                      >
                        <View />
                      </button>
                      <p className="errorMsg">{errors.password?.message}</p>
                    </div>
                  </div>

                  <div className="uk-width-1-1">
                    <div className="btnwrp">
                      {/* <div className="forgetBtn">
                        <a href="/">Forgot password?</a>
                      </div> */}
                      <div className="loginBtn" style={{ width: "100%" }}>
                        <button
                          // onClick={()=> window.location.href = "/dashboard"}
                          type="submit"
                          // disabled={loader ? true : false}
                        >
                          {loader ? (
                            <div uk-spinner="" className="loader"></div>
                          ) : (
                            "Log in"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
